<div class="offering-card rds-shadow-2">
  <div class="offering-card-header">
    @if (displayName()) {
      <h3 class="ui-heading-4-bold offering-card-title">{{ displayName() }}</h3>
    }
    @if (approvalStatus(); as status) {
      <rds-badge
        class="offering-card-status"
        type="minimal"
        [color]="statusColor()"
        [label]="status"
      />
    }
  </div>

  <div class="offering-card-body">
    <!-- Search passes the matched extract so the card can show *why* it came
         back; everywhere else this is the plain description. -->
    @if (descriptionHtml()) {
      <div
        class="offering-card-description ui-body-m"
        [innerHTML]="descriptionHtml()"
      ></div>
    } @else {
      <div class="offering-card-description ui-body-m">{{ description() }}</div>
    }
  </div>

  <div class="offering-card-actions">
    <button
      rds-primary-button
      size="l"
      [routerLink]="['/offerings', slug()]"
      [attr.aria-label]="'Get started with ' + displayName()"
      faroAction="offering card get started"
      [faroActionAttrs]="{ offeringSlug: slug() ?? '' }"
    >
      Get started
    </button>
  </div>
</div>
